import * as Const from '../constants';

import { activeTab$ } from '../selectors/findUser';

import * as FindUserCreator from './findUser';
import * as ActivityCreator from './activity';
import * as CommunicationCreator from './communication';
import * as PaymentsCreators from './paymentsInfo';
import * as UserExplorerActions from '../actions/userExplorer';

import ReduxAction from '../interfaces/ReduxAction';

export function product (): ReduxAction {
  return (dispatch, getState): void => {
    switch (activeTab$(getState())) {
      case Const.PERSONAL_ACTIVE_TAB:
        dispatch(FindUserCreator.findUser());
        dispatch(UserExplorerActions.fetchUserExplorerInitAction());
        break;
      case Const.ACTIVITY_ACTIVE_TAB:
        dispatch(ActivityCreator.activity());
        dispatch(UserExplorerActions.fetchUserExplorerInitAction());
        break;
      case Const.COMMUNICATION_ACTIVE_TAB:
        dispatch(CommunicationCreator.communication());
        dispatch(UserExplorerActions.fetchUserExplorerInitAction());
        break;
      case Const.PAYMENTS_ACTIVE_TAB:
        dispatch(PaymentsCreators.payments());
        dispatch(UserExplorerActions.fetchUserExplorerInitAction());
        break;
      default:
        dispatch(FindUserCreator.findUser());
        dispatch(UserExplorerActions.fetchUserExplorerInitAction());
    }
  };
}
